import { Navigation } from "swiper/modules";
import { SwiperOptions } from "swiper/types";

export const newsCardSliderOptions: SwiperOptions = {
  spaceBetween: 36,
  slidesPerView: 2.25,
  slidesPerGroup: 1,
  grabCursor: true,
  speed: 700,
  direction: "horizontal",
  observer: true,
  mousewheel: {
    forceToAxis: true,
  },
  navigation: {
    enabled: true,
    nextEl: ".swiper-button-next-news-swiper",
    prevEl: ".swiper-button-prev-news-swiper",
  },
  injectStyles: [
    `
       .swiper {
        overflow: visible;     
      } 
    `,
  ],
  breakpoints: {
    0: {
      slidesPerView: 1.2,
      spaceBetween: 15,
    },
    480: {
      slidesPerView: 2.1,
      spaceBetween: 15,
    },
    768: {
      slidesPerView: 2.1,
      spaceBetween: 15,
    },
    1190: {
      slidesPerView: 2.1,
    },
    1500: {
      slidesPerView: 2.25,
    },
    1600: {
      slidesPerView: 2.25,
    },
  },
};
